import {
  notifyError,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api.js'

import mutationInstall from './mutation-install.graphql.js'
import { useDataChange, useDataSubmit, useDataValue } from 'Simple/Data.js'

export default function useListItemDataOnActionInstall(props, data) {
  let install_app_id = useDataValue({
    context: 'tab',
    path: 'selected.install_app_id',
    viewPath: props.viewPath,
  })

  let changeInstallAppId = useDataChange({
    context: 'tab',
    path: 'selected.install_app_id',
    viewPath: props.viewPath,
  })

  let changeFlowShortcutsAppId = useDataChange({
    context: 'flow_shortcuts',
    path: 'installAppId',
    viewPath: props.viewPath,
  })

  let flow_shortcuts = useDataValue({
    context: 'flow_shortcuts',
    viewPath: props.viewPath,
  })
  let submitTab = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let [, executeMutationInstall] = useMutation(mutationInstall)

  return async function onAction({ value, args, change }) {
    if (!value.acceptedTermsAndConditions) return

    let properties = null
    if (value.properties && install_app_id !== null) {
      properties = value.properties
        .map(item => ({
          key: item.key,
          value: flow_shortcuts[item.key] ?? null,
        }))
        .filter(item => item.value !== null)
    }

    let mutationResponse = await executeMutationInstall({
      app_id: value.id,
      properties,
    })
    if (mutationResponse.error || !mutationResponse.data.apps_install.app) {
      return notify(
        notifyError(
          `An error occurred trying to install the "${value.app_name}" app. Please refresh the page and try again.`
        )
      )
    }

    changeInstallAppId(null)
    changeFlowShortcutsAppId(null)

    // need to beat race condition
    setTimeout(() => submitTab({ type: 'manage', app_id: value.id }), 100)

    notify(notifySuccess(`App "${value.app_name}" installed!`))
  }
}
